export default "__VITE_ASSET__CJ8qPppd__"